import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ---
// Services
// ---

import { KeyboardService } from '.';
export class KeyboardModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [KeyboardService],
  declarations: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function KeyboardModule_tsickle_Closure_declarations() {
/** @type {?} */
KeyboardModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
KeyboardModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
